import { computed, toValue, type MaybeRefOrGetter } from 'vue'

export const useCovers = (
  isFlyEuropeActive: MaybeRefOrGetter<boolean>,
  isFlyEurope: MaybeRefOrGetter<boolean>,
  isRegional: MaybeRefOrGetter<boolean>,
  isModal?: boolean
) => {
  const covers = computed(() => {
    const isFlyEuropeActiveValue = toValue(isFlyEuropeActive)
    const isFlyEuropeValue = toValue(isFlyEurope)
    const isRegionalValue = toValue(isRegional)

    return [
      {
        title: 'outbound.select_plan.insurance_values.category_1.label',
        cover: [
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_1.name',
            description: [
              {
                title: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_1_1',
                text: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_1_2',
              },
              {
                title: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_2_1',
                text: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_2_2',
              },
              {
                title: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_3_1',
                text: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_3_2',
              },
              {
                title: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_4_1',
                text: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_4_2',
              },
              {
                title: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_5_1',
                text: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc_5_2',
              },
            ],
            price:
              isFlyEuropeActiveValue && isModal
                ? 'outbound.select_plan.insurance_values.category_1.item_1.desc_flyeurope'
                : 'outbound.select_plan.insurance_values.category_1.item_1.desc',
            priceFlyEurope:
              'outbound.select_plan.insurance_values.category_1.item_1.desc_flyeurope',
            tooltip: 'outbound.select_plan.insurance_values.covered.health.em_medical_care.tooltip',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_2.name',
            description: 'outbound.select_plan.insurance_values.category_1.item_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_1.item_2.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_2_1.name',
            description: 'outbound.select_plan.insurance_values.category_1.item_2_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_1.item_2_1.desc',
            hide: isFlyEuropeValue,
          },
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_2_2.name',
            description: 'outbound.select_plan.insurance_values.category_1.item_2_2.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_1.item_2_2.desc',
            hideInModal: isFlyEuropeActiveValue,
            hide: isFlyEuropeValue,
          },
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_3.name',
            description: 'outbound.select_plan.insurance_values.category_1.item_3.pop_desc',
            price: 'outbound.select_plan.insurance_values.addon',
            hideInModal: isFlyEuropeActiveValue,
            strikethrough: true,
          },
          {
            name: 'outbound.select_plan.insurance_values.category_1.item_4.name',
            description: isRegionalValue
              ? 'outbound.select_plan.insurance_values.category_1.item_4.pop_desc_reg'
              : 'outbound.select_plan.insurance_values.category_1.item_4.pop_desc',
            price: 'outbound.select_plan.insurance_values.addon',
            hideInModal: isFlyEuropeActiveValue,
            strikethrough: true,
          },
        ],
      },
      {
        title: 'outbound.select_plan.insurance_values.category_2.label',
        hideInModal: isFlyEuropeActiveValue,
        strikethrough: isFlyEuropeValue,
        cover: [
          {
            name: 'outbound.select_plan.insurance_values.category_2.item_1.name',
            description: 'outbound.select_plan.insurance_values.category_2.item_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_2.item_1.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_2.item_1_1.name',
            description: 'outbound.select_plan.insurance_values.category_2.item_1_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_2.item_1_1.desc',
            hide: isFlyEuropeValue,
          },
          {
            name: 'outbound.select_plan.insurance_values.category_2.item_2.name',
            description: 'outbound.select_plan.insurance_values.category_2.item_2.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_2.item_2.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_2.item_3.name',
            description: 'outbound.select_plan.insurance_values.category_2.item_3.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_2.item_3.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_2.item_3_1.name',
            description: 'outbound.select_plan.insurance_values.category_2.item_3_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_2.item_3_1.desc',
            hide: isFlyEuropeValue,
          },
        ],
      },
      {
        title: 'outbound.select_plan.insurance_values.category_3.label',
        hideInModal: isFlyEuropeActiveValue,
        strikethrough: isFlyEuropeValue,
        cover: [
          {
            name: isFlyEuropeValue
              ? 'outbound.select_plan.insurance_values.category_3.item_1.name'
              : 'outbound.select_plan.insurance_values.category_3.item_1_1.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_1_1.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_1_1.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_3.item_1_2.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_1_2.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_1_2.desc',
            hide: isFlyEuropeValue,
          },
          {
            name: 'outbound.select_plan.insurance_values.category_3.item_2.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_2.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_2.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_3.item_3.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_3.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_3.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_3.item_4.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_4.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_4.desc',
          },
          {
            name: 'outbound.select_plan.insurance_values.category_3.item_4_1.name',
            description: 'outbound.select_plan.insurance_values.category_3.item_4_3.pop_desc',
            price: 'outbound.select_plan.insurance_values.category_3.item_4_2.desc',
            hide: isFlyEuropeValue,
          },
        ],
      },
    ]
  })

  return {
    covers,
  }
}
